import axios from 'axios';
import { API_AUTH } from '../../config/config';

export const CU_TEST = 'CU_TEST';
export const CU_LOGIN = 'CU_LOGIN';
export const CU_LOGOUT = 'CU_LOGOUT';

export const CUTest = () => {
  return {
    type: CU_TEST,
  };
};

export const CULogIn = data => {
  return {
    type: CU_LOGIN,
    payload: data,
  };
};

export const CULogOut = () => {
  return {
    type: CU_LOGOUT,
  };
};

const fetchCU = (code, state) => {
  return dispatch => {
    axios
      .post(`${API_AUTH}checkstate/desa-extranet`, { code, state })
      .then(res => {
        dispatch(CULogIn({ user: 'va', token: 'va' }));
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export default fetchCU;
